import isEqual from 'lodash/isEqual';

export function areAnyPropsChanged(propList, prevProps, currProps) {
  const changedProps = propList.filter((prop) => {
    if (
      typeof prevProps[prop] === 'object' ||
      typeof currProps[prop] === 'object'
    ) {
      return !isEqual(prevProps[prop], currProps[prop]);
    } else {
      return prevProps[prop] !== currProps[prop];
    }
  });
  return changedProps.length > 0;
}
